import React, { Fragment } from "react";
import { Box } from "@material-ui/core";
import { ThemedAsset } from "nemuru-components";
import Typography from "@material-ui/core/Typography";
import Text from "../../Text";
import { useTheme } from "@material-ui/styles";

export default function EndSectionMessageOK({
  iconName,
  textId,
  hidingMessage,
}) {
  const { palette } = useTheme();
  return (
    <Fragment>
      <Box
        position={"absolute"}
        height={"100%"}
        display="flex"
        alignItems="center"
        justifyContent={"center"}
        top={0}
        left={0}
        width={"100%"}
        style={{
          transform: hidingMessage ? "translateY(50px)" : "translateY(0px)",
        }}
        className={"transition-all"}
      >
        <Typography color={"primary"} variant={"subtitle1"} className={"mb-3"}>
          <i
            className="material-icons circle-border-appear-anim"
            style={{
              verticalAlign: "text-top",
              fontSize: "70px",
              borderRadius: "100px",
            }}
          >
            done
          </i>
        </Typography>
      </Box>
      <Box />
      {textId && (
        <Box
          style={{
            transform: hidingMessage ? "translateY(40px)" : "translateY(0px)",
            opacity: hidingMessage ? 0 : 1,
            transition: "all 0.8s ease",
          }}
        >
          {iconName && (
            <ThemedAsset
              id={iconName}
              width={70}
              height={70}
              style={{ color: palette.secondary.main }}
            />
          )}
          <Typography
            color={"primary"}
            variant={"h6"}
            className={"mt-3 transition-all"}
            style={{
              transform: hidingMessage ? "translateY(15px)" : "translateY(0px)",
              fontSize: 18,
            }}
          >
            <strong>
              <Text tId={textId} />
            </strong>
          </Typography>
        </Box>
      )}
      <Box height={"300px"} />
    </Fragment>
  );
}
